module.exports = __webpack_public_path__ + "img/online_assessment_and_activity_monitoring.2d78e336.svg";